import $Scriptjs from 'scriptjs'

var pickerApiLoaded = false;
var picker = undefined;
var token = undefined;
var parent_folder = undefined;
var callback = undefined;

class dropbox_controller {

  openPickerProyectos(p_token, p_folder_path, p_callback) {

    token = p_token;
    parent_folder = p_folder_path;
    callback = p_callback;

    //p_callback("ni idea")
    
    if (pickerApiLoaded) {
      //gapi.load('picker', this.onPickerApiLoad);
    } else {
      //$Scriptjs.urlArgs('data-app-key=2661biluu3bw2ww');
      $Scriptjs('https://www.dropbox.com/static/api/2/dropins.js', () => {
        pickerApiLoaded = true

        console.log(Dropbox)

        Dropbox.appKey = "2661biluu3bw2ww"

        var url = ""
        var filename = ""
        var options = {
          files: [
              // You can specify up to 100 files.
              {'url': '...', 'filename': '...'},
              {'url': '...', 'filename': '...'},
              // ...
          ],
      
          // Success is called once all files have been successfully added to the user's
          // Dropbox, although they may not have synced to the user's devices yet.
          success: function () {
              // Indicate to the user that the files have been saved.
              alert("Success! Files saved to your Dropbox.");
          },
      
          // Progress is called periodically to update the application on the progress
          // of the user's downloads. The value passed to this callback is a float
          // between 0 and 1. The progress callback is guaranteed to be called at least
          // once with the value 1.
          progress: function (progress) {},
      
          // Cancel is called if the user presses the Cancel button or closes the Saver.
          cancel: function () {},
      
          // Error is called in the event of an unexpected response from the server
          // hosting the files, such as not being able to find a file. This callback is
          // also called if there is an error on Dropbox or if the user is over quota.
          error: function (errorMessage) {}
        };
        Dropbox.save(options);

        //gapi.load('picker', this.onPickerApiLoad);


        /*var options = DropboxChooseOptions = {
            success: function (files) {
                 for (const file of files) {
                        const name = file.name;
                        const url = file.link;
                        console.log({ name: name, url: url });
                    }
            },
            cancel: function () {
            },
            linkType: "direct",
            multiselect: true,
            extensions: ['.pdf', '.doc', '.docx', '.html'],
        };
    
        Dropbox.choose(options);*/

      })
    }
  }

  /*interface Dropbox {
    choose(options: DropboxChooseOptions): void;
    }

    interface DropboxChooseOptions {
        success(files: DropboxFile[]);
        cancel?(): void;
        linkType: "direct" | "preview";
        multiselect: boolean;
        extensions?: string[];
    }

    interface DropboxFile {
        name: string;
        link: string;
        bytes: number;
        icon: string;
        thumbnailLink?: string;
        isDir: boolean;
    }*/

  onPickerApiLoad() {
    /*var uploadView = new google.picker.DocsUploadView();

    uploadView.setParent(parent_folder)
    uploadView.setLabel("Nuevo Documento")

    picker = new google.picker.PickerBuilder()
      .setOAuthToken(token)
      .addView(uploadView)
      .setCallback(callback)
      .hideTitleBar()
      .build();
    picker.setVisible(true);
    */
  }

}

export default new dropbox_controller("", "", "");